// extracted by mini-css-extract-plugin
export default {"checkboxList":"CheckboxList_checkboxList__RF5SX","checkboxItem":"CheckboxList_checkboxItem__U9UUX"};